import { createSystem, defaultConfig } from "@chakra-ui/react";

const theme = createSystem(defaultConfig, {
  globalCss: {
    html: { colorPalette: "brand" },
    "html, body": {
      margin: 0,
      padding: 0,
    },
    "table,td": {
      paddingBlock: ".2em !important",
    },
    "accordion,button": {
      paddingBlock: ".2em !important",
    },
  },
  theme: {
    semanticTokens: {
      colors: {
        bg: {
          DEFAULT: { value: { _light: "{colors.k2e.tableBody}", _dark: "{colors.artesian.tableBody}" } },
          panel: { value: { _light: "{colors.cyan.900}", _dark: "{colors.artesian.header}" } },
          muted: { value: { _light: "{colors.k2e.tableRowOdd}", _dark: "{colors.artesian.tableRowOdd}" } },
          info: {
            value: { _light: "{colors.k2e.facetPanelHighlight}", _dark: "{colors.artesian.facetPanelHighlight}" },
          },
          success: { value: { _light: "#f0fdf4", _dark: "#f0fdf4" } },
          warning: {
            value: { _light: "{colors.k2e.warning}", _dark: "{colors.artesian.warning}" },
          },
        },
        fg: {
          value: { _light: "white", _dark: "white" },
        },
        subtle: { value: { _light: "gray.700", _dark: "gray.700" } },
        ghost: { value: { _light: "{colors.cyan.900}", _dark: "{colors.artesian.button}" } },
        border: {
          DEFAULT: { value: { _light: "white", _dark: "{colors.artesian.button}" } }, // Bordo bianco in dark mode
          success: { value: { _light: "#124a28", _dark: "#124a28" } },
        },
        facetPanel: {
          facetIcon: { value: { _light: "{colors.k2e.facetIcon}", _dark: "{colors.artesian.facetIcon}" } },
          facetBg: { value: { _light: "{colors.k2e.facetBg}", _dark: "{colors.artesian.facetBg}" } },
          oddBackground: { value: { _light: "{colors.k2e.facetPanelOdd}", _dark: "{colors.artesian.facetPanelOdd}" } },
          submenu: { value: { _light: "{colors.k2e.tableHighlight}", _dark: "white" } },
          facetPanelHover: {
            value: { _light: "{colors.k2e.facetPanelHover}", _dark: "{colors.artesian.facetPanelHover}" },
          },
        },
        header: {
          value: { _light: "{colors.k2e.header}", _dark: "{colors.artesian.header}" },
        },
        headerBorder: {
          value: { _light: "white", _dark: "white" },
        },
        page: {
          value: { _light: "{colors.k2e.background}", _dark: "{colors.artesian.background}" },
        },
        sider: {
          value: {
            base: "gray.50",
            _dark: "cyan.900",
          },
        },
        brand: {
          selectedRow: { value: { _light: "{colors.k2e.selectedRow}", _dark: "{colors.artesian.selectedRow}" } },
          solid: { value: { _light: "{colors.k2e.button}", _dark: "{colors.artesian.button}" } },
          contrast: { value: { _light: "white", _dark: "white" } },
          fg: { value: { _light: "rgb(101, 131, 162)", _dark: "white" } },
          muted: { value: "#8d919c" },
          subtle: { value: { _light: "{colors.k2e.tableRowOdd}", _dark: "{colors.artesian.tableRowOdd}" } },
          disabled: { value: { _light: "gray.200", _dark: "gray.200" } },
          emphasized: { value: { _light: "{colors.k2e.emphasized}", _dark: "{colors.artesian.emphasized}" } },
          focusRing: { value: "white" },
          tooltipIcon: { value: { _light: "{colors.k2e.tooltipIcon}", _dark: "{colors.artesian.tooltipIcon}" } },
          toolTipBg: { value: { _light: "{colors.k2e.toolTipBg}", _dark: "{colors.artesian.toolTipBg}" } },
          toolTipText: { value: { _light: "{colors.k2e.toolTipText}", _dark: "{colors.artesian.toolTipText}" } },
          facetPanelHighlight: {
            value: { _light: "{colors.k2e.facetPanelHighlight}", _dark: "{colors.artesian.facetPanelHighlight}" },
          },
          hoverText: { value: { _light: "black", _dark: "black" } },
          customFiltersBg: {
            value: { _light: "{colors.k2e.customFiltersBg}", _dark: "{colors.artesian.customFiltersBg}" },
          },
          okColor: { value: { _light: "green", _dark: "green" } },
          error: { value: { _light: "red", _dark: "red" } },
          success: { value: { _light: "{colors.k2e.success}", _dark: "{colors.artesian.success}" } },
          highlight: { value: { _light: "{colors.k2e.highlight}", _dark: "{colors.artesian.highlight}" } },
        },
        table: {
          primary: { value: { _light: "{colors.k2e.tableBody}", _dark: "{colors.artesian.tableBody}" } },
          secondary: { value: { _light: "{colors.k2e.tableRowOdd}", _dark: "{colors.artesian.tableRowOdd}" } },
          highlight: { value: { _light: "{colors.k2e.tableHighlight}", _dark: "{colors.artesian.tableHighlight}" } },
          buttonBorder: { value: { _light: "{colors.k2e.buttonBorder}", _dark: "{colors.artesian.buttonBorder}" } },
          scrollBar: { value: { _light: "{colors.k2e.scrollBar}", _dark: "{colors.artesian.scrollBar}" } },
          scrollBarTrack: {
            value: { _light: "{colors.k2e.scrollBarTrack}", _dark: "{colors.artesian.scrollBarTrack}" },
          },
        },
        primary: {
          //PaletteExample
          solid: { value: "#4a76ac" }, //The bold fill color of the color.
          contrast: { value: "#ffffff" }, //The text color that goes on solid color.
          fg: { value: "#a3cfff" }, //The foreground color used for text, icons, etc.
          muted: { value: "#14204a" }, //The muted color of the color.
          subtle: { value: "#1a3478" }, //The subtle color of the color.
          emphasized: { value: "#173da6" }, //The emphasized version of the subtle color.
          focusRing: { value: "#2563eb" }, //The focus ring color when interactive element is focused.
        },
        helpColorScheme: {
          //PaletteExample
          solid: { value: { _light: "{colors.k2e.highlight}", _dark: "{colors.artesian.highlight}" } },
          contrast: { value: "#4a76ac" }, //The text color that goes on solid color.
          fg: { value: "#a3cfff" }, //The foreground color used for text, icons, etc.
          muted: { value: "#14204a" }, //The muted color of the color.
          subtle: { value: "#1a3478" }, //The subtle color of the color.
          emphasized: { value: "#173da6" }, //The emphasized version of the subtle color.
          focusRing: { value: "#2563eb" }, //The focus ring color when interactive element is focused.
        },
        error: {
          solid: { value: "#ff5630" },
          contrast: { value: "#ffffff" },
          fg: { value: "#ff745f" },
          muted: { value: "#b00020" },
          subtle: { value: "#ff745f" },
          emphasized: { value: "#ff745f" },
          focusRing: { value: "#ff5630" },
          bg: { value: "#FFFFFF" },
        },
        code: {
          solid: { value: { _light: "#f5f5f5", _dark: "#2d2d2d" } },
          contrast: { value: { _light: "#d63384", _dark: "#ff79c6" } },
          fg: { value: { _light: "#007acc", _dark: "#61dafb" } },
          muted: { value: { _light: "#d69d85", _dark: "#e06c75" } },
          subtle: { value: { _light: "#795e26", _dark: "#d19a66" } },
          emphasized: { value: { _light: "#6a9955", _dark: "#98c379" } },
          focusRing: { value: { _light: "#b5cea8", _dark: "#56b6c2" } },
        },
        mainTabs: {
          solid: { value: { _light: "{colors.k2e.highlight}", _dark: "{colors.artesian.highlight}" } },
          contrast: { value: { _light: "#d63384", _dark: "#ff79c6" } },
          fg: { value: { _light: "#007acc", _dark: "#61dafb" } },
          muted: { value: { _light: "#d69d85", _dark: "#e06c75" } },
          subtle: { value: { _light: "#795e26", _dark: "#d19a66" } },
          emphasized: { value: { _light: "#6a9955", _dark: "#98c379" } },
          focusRing: { value: { _light: "#b5cea8", _dark: "#56b6c2" } },
        },
      },
    },

    tokens: {
      colors: {
        brandPalette: {
          100: { value: "#e4f1ff" },
          200: { value: "#7F7A91" },
          300: { value: "#5A5766" },
          500: { value: "#4094D0" },
          600: { value: "#344663" },
          700: { value: "#FFE6B9" },
          800: { value: "#E4572E" },
          900: { value: "#ffffff" },
        },

        artesian: {
          selectedRow: { value: "#475e7d" },
          header: { value: "#1a2338" },
          background: { value: "#344663" },
          tableBody: { value: "#1d2740" },
          tableRowOdd: { value: "#25304c" },
          tableHighlight: { value: "#293750" },
          emphasized: { value: "#369dad" },
          highlight: { value: "#ffcc05" },
          button: { value: "#475e7d" },
          buttonBorder: { value: "#425879" },
          tooltipIcon: { value: "#7f9fce" },
          scrollBar: { value: "#293750" },
          scrollBarTrack: { value: "#1d2740" },
          facetIcon: { value: "#7f9fce" },
          facetPanelHover: { value: "#495a7a" },
          facetPanelHighlight: { value: "#a1a1aa" },
          facetPanelOdd: { value: "#cfd9e3" },
          facetBg: { value: "#1d2740" },
          toolTipBg: { value: "#cfd9e3;" },
          toolTipText: { value: "#697a91;" },
          customFiltersBg: { value: "#369dad " },
          success: { value: "#4caf50" },
          warning: { value: "#fff1ba" },
        },

        k2e: {
          selectedRow: { value: "#113b4a" },
          header: { value: "#032734" },
          background: { value: "#032734" },
          tableBody: { value: "#032734" },
          tableRowOdd: { value: "#073343" },
          tableHighlight: { value: "#ebedf1" },
          emphasized: { value: "#369dad" },
          highlight: { value: "#EA7224" },
          button: { value: "#113b4a" },
          buttonBorder: { value: "#4D8BA5" },
          tooltipIcon: { value: "#4D8BA5" },
          scrollBar: { value: "white" },
          scrollBarTrack: { value: "#595959" },
          facetIcon: { value: "#4D8BA5" },
          facetPanelHover: { value: "#495a7a" },
          facetPanelHighlight: { value: "#a1a1aa" },
          facetPanelOdd: { value: "#cecece" },
          facetBg: { value: "#083a4c" },
          toolTipBg: { value: "#cfd9e3;" },
          toolTipText: { value: "#697a91;" },
          customFiltersBg: { value: "#369dad " },
          success: { value: "#4caf50" },
          warning: { value: "#fff1ba" },
        },
        status: {
          success: { value: "#008001" },
          warning: { value: "#ffff00" },
          error: { value: "#ff0000" },
          default: { value: "gray" },
        },
        brand: {
          primary: { value: "black" },
          dark: { value: "#194069" },
          errorBackGround: { value: "#ff6565" },
          errorText: { value: "#460e0e" },
        },
        fonts: {
          heading: { value: `'PTSansRegular', sans-serif` },
          body: { value: `'PTSansRegular', sans-serif` },
        },
      },
    },
  },
});

export default theme;
